export default __webpack_public_path__ + "static/media/alarm-add.06f83278.svg";